import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';


import { Question } from '../../../shared/models/question/question';
import { QuestionAnswerOption } from '../../../shared/models/question/question-answer-option';

import { QuestionService } from 'app/core/services/question.service';

@Component({
  selector: 'app-user-step-summary-course-question',
  templateUrl: './user-step-summary-course-question.component.html',
  styleUrls: ['./user-step-summary-course-question.component.scss']
})
export class UserStepSummaryCourseQuestionComponent implements OnInit {

  @Input()
  courseId: number;

  @Input()
  questions: Array<Question>;

  @Output()
  stepLoaded: EventEmitter<any> = new EventEmitter();

  @Output()
  sectionLoaded: EventEmitter<any> = new EventEmitter();


  constructor(private questionService: QuestionService) { }

  ngOnInit() {
    this.sectionLoaded.emit();
  }



}
